import { authHeader, isTokenExpired } from "../helpers";

export const EntityService = {
  getEntities,
  getEntity,
  getFullEntity,
  createEntity,
  updateEntity,
  deleteEntity,
  exists,
  search,
  updateVisible,
  updatePublish,
};

function getEntities(type, offset = -1, limit = -1) {
  const requestOptions = {
    method: "GET",
    headers: authHeader(),
  };

  const url =
    offset >= 0 && limit > 0
      ? `${process.env.REACT_APP_GATEWAY_URL}/admin/entity?type=${type}&offset=${offset}&limit=${limit}`
      : `${process.env.REACT_APP_GATEWAY_URL}/admin/entity?type=${type}&offset=0&limit=100`;

  return fetch(url, requestOptions)
    .then((res) => isTokenExpired(res))
    .then((res) => {
      if (res.status === 200) {
        return res.json();
      } else {
        const error = (res && res.message) || res.statusText;
        return Promise.reject(error);
      }
    });
}

function getEntity(id) {
  const requestOptions = {
    method: "GET",
    headers: authHeader(),
  };
  return fetch(
    `${process.env.REACT_APP_GATEWAY_URL}/admin/entity/${id}`,
    requestOptions
  )
    .then((res) => isTokenExpired(res))
    .then((res) => {
      if (res.status === 200) {
        return res.json();
      } else {
        const error = (res && res.message) || res.statusText;
        return Promise.reject(error);
      }
    });
}

function getFullEntity(id) {
  const requestOptions = {
    method: "GET",
    headers: authHeader(),
  };
  return fetch(
    `${process.env.REACT_APP_GATEWAY_URL}/admin/entity/${id}/full`,
    requestOptions
  )
    .then((res) => isTokenExpired(res))
    .then((res) => {
      if (res.status === 200) {
        return res.json();
      } else {
        const error = (res && res.message) || res.statusText;
        return Promise.reject(error);
      }
    });
}

function createEntity(entity) {
  const form = new FormData();
  form.append("entity", JSON.stringify(entity));
  if (entity.logoFile && entity.logoFile.length > 0)
    form.append(
      "logo",
      entity.logoFile[0],
      entity.logoFile[0].name.replaceAll(/\s/g, "")
    );
  if (entity.headerFile && entity.headerFile.length > 0)
    form.append(
      "header",
      entity.headerFile[0],
      entity.headerFile[0].name.replaceAll(/\s/g, "")
    );
  if (entity.museumLogo && entity.museumLogo.length > 0)
    form.append(
      "museumLogo",
      entity.museumLogo[0],
      entity.museumLogo[0].name.replaceAll(/\s/g, "")
    );
  const requestOptions = {
    method: "POST",
    headers: authHeader(true),
    body: form,
  };
  return fetch(
    `${process.env.REACT_APP_GATEWAY_URL}/admin/entity`,
    requestOptions
  )
    .then((res) => isTokenExpired(res))
    .then((res) => {
      if (res.status < 300) {
        return res.json();
      } else {
        const error = (res && res.message) || res.statusText;
        return Promise.reject(error);
      }
    });
}

function updateEntity(entity) {
  const form = new FormData();
  form.append("entity", JSON.stringify(entity));
  if (entity.logoFile && entity.logoFile.length > 0)
    form.append(
      "logo",
      entity.logoFile[0],
      entity.logoFile[0].name.replaceAll(/\s/g, "")
    );
  if (entity.headerFile && entity.headerFile.length > 0)
    form.append(
      "header",
      entity.headerFile[0],
      entity.headerFile[0].name.replaceAll(/\s/g, "")
    );
  if (entity.museumLogoFile && entity.museumLogoFile.length > 0)
    form.append(
      "museumLogo",
      entity.museumLogoFile[0],
      entity.museumLogoFile[0].name.replaceAll(/\s/g, "")
    );
  if (entity.watermarkFile && entity.watermarkFile.length > 0)
    form.append(
      "watermark",
      entity.watermarkFile[0],
      entity.watermarkFile[0].name.replaceAll(/\s/g, "")
    );
  const requestOptions = {
    method: "PUT",
    headers: authHeader(true),
    body: form,
  };
  return fetch(
    `${process.env.REACT_APP_GATEWAY_URL}/admin/entity`,
    requestOptions
  )
    .then((res) => isTokenExpired(res))
    .then((res) => {
      if (res.status === 200) {
        return res.json();
      } else {
        const error = (res && res.message) || res.statusText;
        return Promise.reject(error);
      }
    });
}

function deleteEntity(id) {
  const requestOptions = {
    method: "DELETE",
    headers: authHeader(),
  };
  return fetch(
    `${process.env.REACT_APP_GATEWAY_URL}/admin/entity/${id}`,
    requestOptions
  )
    .then((res) => isTokenExpired(res))
    .then((res) => {
      if (res.status === 200) {
        return res.json();
      } else {
        const error = (res && res.message) || res.statusText;
        return Promise.reject(error);
      }
    });
}

function exists(name) {
  const requestOptions = {
    method: "GET",
    headers: authHeader(),
  };
  return fetch(
    `${process.env.REACT_APP_GATEWAY_URL}/admin/entity/${name}/exists`,
    requestOptions
  )
    .then((res) => isTokenExpired(res))
    .then((res) => {
      if (res.status === 200) {
        return res.json();
      } else {
        const error = (res && res.message) || res.statusText;
        return Promise.reject(error);
      }
    });
}

function search(name) {
  const requestOptions = {
    method: "GET",
    headers: authHeader(),
  };
  return fetch(
    `${process.env.REACT_APP_GATEWAY_URL}/admin/entity/search?name=${name}`,
    requestOptions
  )
    .then((res) => isTokenExpired(res))
    .then((res) => {
      if (res.status === 200) {
        return res.json();
      } else {
        const error = (res && res.message) || res.statusText;
        return Promise.reject(error);
      }
    });
}

function updateVisible(id, value) {
  const requestOptions = {
    method: "PUT",
    headers: authHeader(),
  };

  const url = value
    ? `${process.env.REACT_APP_GATEWAY_URL}/admin/entity/visible/${id}`
    : `${process.env.REACT_APP_GATEWAY_URL}/admin/entity/invisible/${id}`;

  return fetch(url, requestOptions)
    .then((res) => isTokenExpired(res))
    .then((res) => {
      if (res.status === 200) {
        return res.json();
      } else {
        const error = (res && res.message) || res.statusText;
        return Promise.reject(error);
      }
    });
}

function updatePublish(id, value) {
  const requestOptions = {
    method: "PUT",
    headers: authHeader(),
  };
  const url = value
    ? `${process.env.REACT_APP_GATEWAY_URL}/admin/entity/publish/${id}`
    : `${process.env.REACT_APP_GATEWAY_URL}/admin/entity/unpublish/${id}`;

  return fetch(url, requestOptions)
    .then((res) => isTokenExpired(res))
    .then((res) => {
      if (res.status === 200) {
        return res.json();
      } else {
        const error = (res && res.message) || res.statusText;
        return Promise.reject(error);
      }
    });
}
